import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {UserService} from '../services/user.service';
import {User} from '../models/user';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import {ChannelService} from '../services/channel.service';

@Injectable({
    providedIn: 'root'
})
export class ChannelItemResolver  {

    constructor(
        private _userService: UserService,
        private _channelService: ChannelService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {

        return this._channelService.getItemAPI(parseInt(route.paramMap.get('id')));
    }
}
